(function () {
  var SECTION_SELECTOR = '.oddit-section-product-recommendation';

  function loadRecommendations(section) {
    if (!section) return;
    if (section.dataset.odditLoaded === '1') return;
    if (section.dataset.loading !== 'true') return;

    var url = section.dataset.fetchUrl;
    if (!url) return;

    section.dataset.odditLoaded = '1';

    fetch(url, { credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Recommendations request failed: ' + response.status);
        }
        return response.text();
      })
      .then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var fresh = doc.querySelector(SECTION_SELECTOR);
        if (!fresh) return;

        var freshContainer = fresh.querySelector('.oddit-section-product-recommendation__container');
        var ownContainer = section.querySelector('.oddit-section-product-recommendation__container');
        if (!freshContainer || !ownContainer) return;

        ownContainer.innerHTML = freshContainer.innerHTML;
        section.removeAttribute('data-loading');

        var shopifySection = section.closest('.shopify-section');
        if (shopifySection) {
          shopifySection.dispatchEvent(
            new CustomEvent('shopify:section:load', {
              bubbles: true,
              detail: { sectionId: section.dataset.sectionId },
            })
          );
        }
      })
      .catch(function (error) {
        section.removeAttribute('data-loading');
        section.dataset.odditLoaded = '';
        if (window.console && console.warn) {
          console.warn('[oddit] Product recommendations failed to load:', error);
        }
      });
  }

  function initAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll(SECTION_SELECTOR).forEach(loadRecommendations);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (!e || !e.target || !e.target.querySelector) return;
    var section = e.target.querySelector(SECTION_SELECTOR);
    if (section) {
      section.dataset.odditLoaded = '';
      loadRecommendations(section);
    }
  });
})();
